<template>
  <Modal v-model="finishDebtModal" width="500">
    <p slot="header" class="text-center">新建电费收款单</p>
    <Form
      :model="formData"
      :rules="ruleValidate"
      ref="formData"
      :label-width="100"
    >
      <FormItem label="收款单名称" prop="billName">
          <Input v-model="formData.billName" placeholder="请输入收款单名称"></Input>
      </FormItem>
      <FormItem label="预计付款日期" prop="expectPayDate">
        <DatePicker type="date" placeholder="请设置预计付款日期" v-model="formData.expectPayDate"></DatePicker>
        <p class="remark">ps: 因生成出制式缴费通知单的要求，此项需主动填写</p>
      </FormItem>
      <FormItem label="所属合同" prop="contractId">
          <Select
              v-model="formData.contractId"
              filterable
               placeholder="请选择所属合同"
              :remote-method="remoteContractList"
              :loading="contractLoading"
          >
              <Option v-for="(item, index) in contractArray" :value="item.contractId" :key="index">{{item.contractName}}（{{ item.contractCode }}）</Option>
          </Select>
      </FormItem>
      <FormItem label="备注" prop="mark">
        <Input
          v-model.trim="formData.mark"
          size="small"
          type="textarea"
          :rows="4"
          placeholder="填写收款备注信息.."
        />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" class="m-r-5" @click="finishDebtModal = false">取消</Button>
      <Button
        type="success"
        class="m-r-5"
        :loading="submitLoading"
        @click="onConfirm()"
        >确认</Button
      >
    </div>
  </Modal>
</template>

<script>
import { ParseDate } from '@/utils/dateFormat'
import { addElectricBill } from '@/api/invest/electricMeterBill'
import { pgeElectricMetricContract } from '@/api/invest/electricMeterRecord'

export default {
  data () {
    return {
      finishDebtModal: false,

      contractLoading: false,
      submitLoading: false,

      contractArray: [],

      formData: {
        billName: '',
        contractId: null,
        expectPayDate: null,
        mark: ''
      },
      ruleValidate: {
        contractId: [
          { required: true, type: 'number', message: '收款日期不能为空', trigger: 'change' }
        ],
        expectPayDate: [
          { required: true, type: 'date', message: '预计付款日期不能为空', trigger: 'change' }
        ],
        billName: [
          { required: true, type: 'string', message: '收款单名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    showModal () {
      this.formData = {
        billName: '',
        contractId: null,
        expectPayDate: null,
        mark: ''
      }
      this.finishDebtModal = true
    },
    remoteContractList (query) {
      if (query !== '') {
        this.contractLoading = true
        const queryModel = {
          keyWord: query,
          current: 1,
          size: 100
        }

        pgeElectricMetricContract(queryModel).then(res => {
          this.contractLoading = false
          this.contractArray = res.records
        })
      } else {
        this.contractArray = []
      }
    },
    onConfirm () {
      const _self = this
      _self.$refs.formData.validate((valid) => {
        if (valid) {
          _self.formData.expectPayDate = ParseDate(_self.formData.expectPayDate)
          _self.finishDebtModal = false
          _self.submitLoading = false

          addElectricBill(_self.formData).then((res) => {
            _self.$emit('on-success')
            _self.$Notice.success({ desc: '操作成功' })
          }).finally(() => {
            _self.finishDebtModal = false
            _self.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
